import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './form-check-eligibility-business-strata-account.component.scss';
import * as $ from 'jquery';
var FormCheckEligibilityBusinessStrataAccount = /** @class */ (function (_super) {
    tslib_1.__extends(FormCheckEligibilityBusinessStrataAccount, _super);
    function FormCheckEligibilityBusinessStrataAccount(element) {
        return _super.call(this, element) || this;
    }
    FormCheckEligibilityBusinessStrataAccount.prototype.init = function () {
        this.checkEligibility = new CheckEligibility();
        this.form = this.element.querySelector('form');
        this.radioStrata = Array.from(this.element.querySelectorAll('.js-trust-service-provider__radio'));
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-check-eligibility-submit__button'));
        this.containerFields = this.element.querySelector('.form__fields--container');
        this.containerThankYou = this.element.querySelector('.form__thankyou--container');
        this.containerInvalid = this.element.querySelector('.js-invalid-container');
        this.containerValid = this.element.querySelector('.js-valid-container');
        this.containerLoader = this.element.querySelector('.form__loader--container');
        this.valueModalId = this.element.closest('.js-apply-now-modal').getAttribute('id');
        this.containerModal = this.element.closest('.form-container');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        this.valuesJson = {
            operation: "open",
            category: "business",
            leadType: "CallBack_TCSP",
            leadCTA: "CHECK ELIGIBILITY",
            eligibilityCTA: "Call Me Back",
            leadStatus: "Open",
            eligibilityFormId: "",
            clientTCSP: "",
            productName: "",
            pageUrl: ""
        };
    };
    FormCheckEligibilityBusinessStrataAccount.prototype.bindEvents = function () {
        var _this = this;
        // radio buttons- private client
        this.radioStrata.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            if (element.value == "yes") {
                _this.valuesJson.clientTCSP = 'Y';
            }
            else {
                _this.valuesJson.clientTCSP = 'N';
            }
        }); });
        // submit button
        this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formModal = _this.element.closest('.js-apply-now-modal');
            _this.valueModalId = formModal.getAttribute('id');
            var formFields = _this.containerFields.querySelectorAll('input, select');
            var validation = _this.validationService.validateEnterprise(formFields);
            if (validation.valid) {
                if (_this.valuesJson.clientTCSP !== '') {
                    if (_this.valuesJson.clientTCSP === 'Y') {
                        _this.applyFilters('callmeback', _this.valueModalId);
                    }
                    else {
                        _this.containerFields.classList.add('hidden');
                        _this.containerThankYou.classList.add('active');
                        _this.containerInvalid.classList.add('active');
                        _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
                        _this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
                    }
                }
                else {
                    _this.radioStrata.map(function (item, index) {
                        var parent = item.closest('.form__group');
                        parent.classList.add('form__group--error');
                    });
                }
            }
            else {
                _this.containerInvalid.classList.add('active');
                _this.containerThankYou.classList.add('active');
                _this.containerFields.classList.add('hidden');
                _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
                _this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
            }
        }); });
        // close button - reset form
        this.closeButton.addEventListener('click', function (event) {
            _this.containerValid.classList.remove('active');
            _this.containerInvalid.classList.remove('active');
            _this.containerValid.classList.add('form-check-eligibility-seafarer-bank-account--hidden');
            _this.containerInvalid.classList.add('form-check-eligibility-seafarer-bank-account--hidden');
        });
        $(document).on('click', "a.js-apply-now-modal-open[data-modal='" + this.valueModalId + "']", function (event) {
            var element = event.target;
            var parentAttribute = "";
            if (element.closest('.product-offering-exchange__button')) {
                parentAttribute = element.closest('.product-offering-exchange__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.comparison-exchange__product__button')) {
                parentAttribute = element.closest('.comparison-exchange__product__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.detailed-product-card-exchange__buttons-js')) {
                parentAttribute = element.closest('.detailed-product-card-exchange__buttons-js').getAttribute('data-buttonclass');
            }
            if (parentAttribute === 'Eligibility') {
                var type = $(element).attr('data-productname');
                var modal = $(element).attr('data-modal');
                var data = $(element).attr('data-text');
                var dataArray = data.split(" | ");
                var dataNewFormName = "checkeligibility | wealth business | " + type;
                _this.form.setAttribute('data-frmcontainer', dataNewFormName);
                _this.valuesJson.pageUrl = window.location.href;
                if (type) {
                    _this.valuesJson.productName = type;
                }
                if (modal) {
                    _this.valuesJson.eligibilityFormId = modal;
                }
                _this.formstart();
                // APPLICATION ID
                var valueProductID = $(element).closest('.js-product-id').attr('data-productid');
                console.log('Modal ID', modal);
                console.log('Product ID', valueProductID);
                _this.checkEligibility.checkApplicationID(modal, valueProductID, dataNewFormName, type);
            }
        });
    };
    FormCheckEligibilityBusinessStrataAccount.prototype.applyFilters = function (type, modalId) {
        var typeValue = type;
        var modalIdValue = modalId;
        var containerLoader = this.containerLoader;
        var containerThankyou = this.containerThankYou;
        var containerFields = this.containerFields;
        var containerValid = this.containerValid;
        var containerInvalid = this.containerInvalid;
        var checkEligibility = this.checkEligibility;
        containerFields.classList.add('hidden');
        containerLoader.classList.add('active');
        // variables
        var response = 'invalid';
        // fields
        var operation = this.valuesJson.operation;
        var category = this.valuesJson.category;
        var leadType = this.valuesJson.leadType;
        var leadCTA = this.valuesJson.leadCTA;
        var eligibilityCTA = this.valuesJson.eligibilityCTA;
        var leadStatus = this.valuesJson.leadStatus;
        var eligibilityFormId = this.valuesJson.eligibilityFormId;
        var clientTCSP = this.valuesJson.clientTCSP;
        var productName = this.valuesJson.productName;
        var pageUrl = this.valuesJson.pageUrl;
        var applicationID = this.checkEligibility.applicationID;
        var productID = this.checkEligibility.applicationProductID;
        // build string
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (category) {
            postData += 'category=' + category + '&';
        }
        if (leadType) {
            postData += 'leadType=' + leadType + '&';
        }
        if (leadCTA) {
            postData += 'leadCTA=' + leadCTA + '&';
        }
        if (eligibilityCTA) {
            postData += 'eligibilityCTA=' + eligibilityCTA + '&';
        }
        if (leadStatus) {
            postData += 'leadStatus=' + leadStatus + '&';
        }
        if (eligibilityFormId) {
            postData += 'eligibilityFormId=' + eligibilityFormId + '&';
        }
        if (clientTCSP) {
            postData += 'clientTCSP=' + clientTCSP + '&';
        }
        if (productName) {
            postData += 'productName=' + productName + '&';
        }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        if (applicationID) {
            postData += 'appID=' + applicationID + '&';
        }
        if (productID) {
            postData += 'productID=' + productID + '&';
        }
        // config
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            if (response.data === 'invalid') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                containerValid.classList.remove('active');
                containerLoader.classList.remove('active');
                containerFields.classList.remove('hidden');
                checkEligibility.changeButtons(typeValue, modalId, '');
            }
            else {
                var responseData = response.data;
                containerLoader.classList.remove('active');
                containerInvalid.classList.remove('active');
                containerValid.classList.add('active');
                containerThankyou.classList.add('active');
                containerFields.classList.add('hidden');
                checkEligibility.changeButtons('callmeback', modalIdValue, responseData);
                analyticsService.dtmFormCompleteEligibility('complete', responseData.leadID, true, 'Eligible');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
        });
    };
    // reset form
    FormCheckEligibilityBusinessStrataAccount.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormCheckEligibilityBusinessStrataAccount.prototype.formstart = function () {
        var dataNewFormName = "checkeligibility | wealth business | " + this.valuesJson.productName;
        this.analyticsService.dtmFormNameUpdate(dataNewFormName);
        this.analyticsService.dtmAllowFormRefresh();
    };
    return FormCheckEligibilityBusinessStrataAccount;
}(Base));
export { FormCheckEligibilityBusinessStrataAccount };



//////////////////
// WEBPACK FOOTER
// ./components/form-check-eligibility-business-strata-account/form-check-eligibility-business-strata-account.component.ts
// module id = 304
// module chunks = 0